import React, { useMemo, useEffect } from 'react'
import { Switch, Route } from 'react-router-dom'
import Media from 'react-media'

import config from './config'
import routes from './routes'
import { SIZES } from './styles/theme'
import PrivateRoute from './containers/PrivateRoute'

import ActiveUserCountPage from './pages/ActiveUserCountPage'
import UserSessionPage from './pages/UserSessionPage'
import SessionReportPage from './pages/SessionReportPage'
import CountdownPage from './pages/CountdownPage'
import RegisterFormPage from './pages/registration/RegisterFormPage'
import PostRegisterPage from './pages/registration/PostRegisterPage'
import { PreCache } from './containers/PreCache'
import { LoginPage } from './pages/LoginPage'
import { LobbyPage } from './webOnlyPages/LobbyPage'
import { DesktopAgenda } from './webOnlyPages/DesktopAgenda'
import { MobileAgenda } from './mobileOnlyPages/MobileAgenda'
import AuditoriumPage from './webOnlyPages/AuditoriumPage'
import BoothPage from './webOnlyPages/BoothPage'
import MobileBooth from './webOnlyPages/MobileBooth'

declare global {
  interface Window {
    chaport: any
  }
}

function App() {
  useEffect(() => {
    document.title = config.eventName
  }, [])

  useEffect(() => {
    window.chaport.q('hideLauncher')
  }, [])

  return useMemo(() => {
    return (
      <div id="innerBody">
        <Switch>
          <Route exact path={routes.root} component={CountdownPage} />

          <Route exact path={routes.register} component={RegisterFormPage} />
          <Route exact path={routes.postRegister} component={PostRegisterPage} />
          
          <Route exact path="/session-reports" component={SessionReportPage} />
          <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/realtime" component={ActiveUserCountPage} />
          <PrivateRoute blockedRoles={['participant', 'exhibitor', 'speaker']} exact path="/sessions" component={UserSessionPage} />
          <Route exact path={routes.login} component={LoginPage} />
        </Switch>

        <Media query={`(max-width: ${SIZES.mobileBreakpoint})`}>
          {(matches) =>
            matches ? (
              // MOBILE ROUTES
              <PreCache deviceType={'mobile'}>
                <Switch>
                  <PrivateRoute fixedNav path={routes.lobby} component={LobbyPage} />
                  <PrivateRoute fixedNav path={routes.programme} component={MobileAgenda} />
                  <PrivateRoute fixedNav path="/auditorium-hall/:sessionId" component={(props) => <AuditoriumPage {...props} />} />
                  <PrivateRoute path="/booths/:boothId" component={MobileBooth} />

                </Switch>
              </PreCache>
            ) : (
              // DESKTOP ROUTES
              <PreCache deviceType={'desktop'}>
                <Switch>
                  <PrivateRoute fixedNav path={routes.lobby} component={LobbyPage} />
                  <PrivateRoute fixedNav path={routes.programme} component={DesktopAgenda} />
                  <PrivateRoute fixedNav path="/auditorium-hall/:sessionId" component={(props) => <AuditoriumPage {...props} />} />
                  <PrivateRoute fixedNav path="/booths/:boothId" component={BoothPage} />
                </Switch>
              </PreCache>
            )
          }
        </Media>
      </div>
    )
  }, [])
}

export default App
